"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ArrowLeft = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _core = require("@emotion/core");

var ArrowLeft = function ArrowLeft(props) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _core.jsx)("path", {
    d: "M12.98 23.02a.5.5 0 10.707-.707L7.873 16.5h17.46a.5.5 0 000-1H7.873l5.814-5.813a.5.5 0 00-.707-.707l-6.667 6.666a.499.499 0 00-.109.163l-.001.003a.498.498 0 00.001.38l.004.008c.024.055.059.108.105.154l6.667 6.666z",
    fill: "#1F2D27"
  }));
};

exports.ArrowLeft = ArrowLeft;
ArrowLeft.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ArrowLeft"
};